import { StyledGuideItem, TGuideItem } from '@r1-frontend/ui-react/components/Guide/GuideItem';

export interface IGuide {
    items: TGuideItem[],
}

export const Guide = ({ items }: IGuide) => {
    return (
        <>
            {items.map(item => <StyledGuideItem key={item.title} data-test='guide-item' {...item}/>)}
        </>
    );
};
